import config from './config';

const zoomOutLimit = config.zoom.out;
const zoomInLimit = config.zoom.in;

const limitZoomOut = (matrix: DOMMatrix) => {
  if (matrix.a < zoomOutLimit) {
    matrix.a = zoomOutLimit;
  }
  if (matrix.d < zoomOutLimit) {
    matrix.d = zoomOutLimit;
  }

  return matrix;
};

const limitZoonIn = (matrix: DOMMatrix) => {
  if (matrix.a > zoomInLimit) {
    matrix.a = zoomInLimit;
  }
  if (matrix.d > zoomInLimit) {
    matrix.d = zoomInLimit;
  }

  return matrix;
};

const limitMovementY = (matrix: DOMMatrix) => {
  if (matrix.a > zoomOutLimit || matrix.d > zoomOutLimit) {
    /**
     * The original virtual size of the map, aka without zoom
     */
    const mapHeight = config.canvas.height;
    /**
     * The current zoom factor
     */
    const zoom = matrix.a;
    /**
     * The virtual height of the map in the canvas
     *  timed by the zoom factor
     */
    const canvasHeight = Math.ceil(mapHeight * zoom);
    /**
     * Remove the virtual size from the virtual zoomed size
     *  and this is how much it can go dragging from bottom to top
     */
    const bottomLimit = canvasHeight - mapHeight;

    if (matrix.f < -bottomLimit) {
      matrix.f = -bottomLimit;
    }
    if (matrix.f > 0) {
      matrix.f = 0;
    }
  } else {
    matrix.f = 0;
  }

  return matrix;
};

const limitMovementX = (matrix: DOMMatrix) => {
  const canvasWidth = config.canvas.width;
  const zoom = matrix.a;

  const offsetX = matrix.e / (canvasWidth * zoom);

  if (offsetX >= 1 || offsetX <= -1) {
    matrix.e = 0;
  }

  return matrix;
};

const limitMatrix = (matrix: DOMMatrix) => {
  matrix = limitZoomOut(matrix);
  matrix = limitZoonIn(matrix);
  matrix = limitMovementY(matrix);
  matrix = limitMovementX(matrix);

  return matrix;
};

export default limitMatrix;
